import { render, staticRenderFns } from "./UserDetailsResponseHistory.vue?vue&type=template&id=37c8e2ba&"
import script from "./UserDetailsResponseHistory.vue?vue&type=script&lang=ts&"
export * from "./UserDetailsResponseHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports